import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as animationData from './data.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const Clock = ({ width, height }) => {
  return (
    <Lottie
      options={defaultOptions}
      isClickToPauseDisabled
      width={width}
      height={height}
    />
  )
}

Clock.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
}

export default Clock
